<template>
  <div style="margin: 4px 16px 16px;">
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <el-table-column property="area" label="示例图">
        <template #default="scope">
          <el-image class="item-img" style="cursor: pointer" fit="cover" :src="scope.row.standardSmallImg" @click="showImg(scope.row.standardImg)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
        </template>
      </el-table-column>
      <el-table-column property="area" label="上传图">
        <template #default="scope">
          <el-image class="item-img" style="cursor: pointer" fit="cover" :src="scope.row.smallImg" @click="showImg(scope.row.img)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
        </template>
      </el-table-column>
      <el-table-column property="adminName" label="拍摄者"/>
      <el-table-column property="updateTime" label="上传时间" />
    </el-table>
  </div>
</template>

<script>
import {getFormData, postFormData} from '@/api/api';
import {} from '@/api/url';
import ImgViewer from "@/assets/js/imageViewer";
export default {
  props: {
    value: Object
  },
  components: {},
  data() {
    return {
      pageDataList: this.value.imgList,
      userForm: this.value.userForm,
      pageType: this.value.pageType,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList
      })
    },

  },
  mounted() {

  }
}
</script>

<style>
.item-img {
  width: 80px;
  height: 80px;
}
</style>
